<div *ngIf="loading" class="card-base"></div>
<form *ngIf="!generated" [formGroup]="form" (ngSubmit)="generate()">
    <div *ngIf="!loading" class="edit-actions">
        <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
        <button *ngIf="!loadingAction" matTooltip="Cancelar" type="button" (click)="close()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
        <button *ngIf="!loadingAction && !showReport" matTooltip="Generar" type="submit" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>
    </div>


    <mat-tab-group *ngIf="!showReport" (selectedTabChange)="selectedTabChange($event)" #tabGroup>

        <mat-tab label="{{ title }}">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard">
                    <mat-spinner *ngIf="loading"></mat-spinner>

                    <app-billing-invoice-edit-control (loaded)="onLoaded()" [visibleCirculacionAbierta]="visibleCirculacionAbierta" [visibleBillingInvoiceAssociate]="visibleBillingInvoiceAssociate" [visibleDatesFromTo]="visibleDatesFromTo" [enabledClientSearch]="enabledClientSearch" [visibleIsRejectedOptions]="visibleIsRejectedOptions"
                        (invoicePointChange)="onInvoicePointChange()" (clientChange)="onClientChange()" *ngIf="!loading" formControlName="BillingInvoice"></app-billing-invoice-edit-control>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="{{ titleItems }}">
            <div class="card-base  margin-botton-medium">
                <div class="card-content-wizard">
                    <mat-spinner *ngIf="loadingPreBillingIvoiceItems"></mat-spinner>
                    <app-billing-invoice-item-entity-edit [id]="id" formControlName="Items" *ngIf="!loadingPreBillingIvoiceItems && visibleBillingInvoiceItemEntity"></app-billing-invoice-item-entity-edit>
                    <app-billing-invoice-item-entity-credit-edit formControlName="Items" *ngIf="!loadingPreBillingIvoiceItems && visibleBillingInvoiceItemEntityCredit"></app-billing-invoice-item-entity-credit-edit>
                    <app-billing-invoice-item-manual-edit [noDeleteItem]="noDeleteItemManual" [id]="id" formControlName="Items" *ngIf="!loadingPreBillingIvoiceItems && visibleBillingInvoiceItemManual"></app-billing-invoice-item-manual-edit>
                </div>
            </div>
        </mat-tab>




    </mat-tab-group>


    <app-billing-invoive-view *ngIf="showReport" [billingInvoiceId]="billingInvoiceId"></app-billing-invoive-view>
</form>
